import React from 'react';
import { Paper, Typography, Box, Tooltip } from '@mui/material';

const ActivityTimeline = ({ timelineYears, activities, handleActivityClick, highlightedStandIds }) => {
    return (
        <div style={{ marginTop: '20px', overflowX: 'auto' }}>
            <Typography variant="h6" gutterBottom>Timeline View</Typography>
            <Box display="flex" sx={{ minWidth: '800px', border: '1px solid #ddd', borderRadius: '4px' }}>
                {timelineYears.map(year => (
                    <Box key={year} sx={{ flex: 1, borderRight: '1px solid #eee', minWidth: '150px' }}>
                        <Typography variant="subtitle2" align="center" sx={{ bgcolor: '#eee', py: 0.5 }}>
                            {year}
                        </Typography>
                        <Box display="flex">
                            {[1, 2, 3, 4].map(q => {
                                const qActivities = activities.filter(a => a.planned_year === year && a.planned_quarter === q);
                                return (
                                    <Box key={q} sx={{ flex: 1, borderRight: q < 4 ? '1px solid #f9f9f9' : 'none', minHeight: '80px', p: 0.5 }}>
                                        <Typography variant="caption" color="textSecondary" align="center" display="block">Q{q}</Typography>
                                        {qActivities.map(a => (
                                            <Tooltip key={a.id} title={`${a.activity_type} - Stand #${a.stand_number}`}>
                                                <Box 
                                                    onClick={() => handleActivityClick(a)}
                                                    sx={{ 
                                                        bgcolor: highlightedStandIds.includes(a.stand_id) ? '#1976d2' : '#81c784',
                                                        color: 'white',
                                                        borderRadius: '2px',
                                                        fontSize: '10px',
                                                        p: 0.2,
                                                        mb: 0.2,
                                                        cursor: 'pointer',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    #{a.stand_number} {a.activity_type}
                                                </Box>
                                            </Tooltip>
                                        ))}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                ))}
            </Box>
        </div>
    );
};

export default ActivityTimeline;
